<template>
    <div class="flex justify-between">
        <label class="block text-sm font-medium leading-5 text-gray-700" v-bind="$attrs">
            {{ value }}
            <slot></slot>
        </label>
        <div>
            <slot name="corner" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormLabel',
    props: ['value'],
    inheritAttrs: false,
};
</script>
